export enum Classification {
  RURAL = 'RURAL',
  URBAN = 'URBAN',
}

export enum ClassificationOpportunityAndRisk {
  LOW = 'LOW',
  MEDIUM_LOW = 'MEDIUM_LOW',
  MEDIUM_HIGH = 'MEDIUM_HIGH',
  HIGH = 'HIGH',
}
